/** Host-local notification/SSE type strings (DR-5 — not foundation contract). */

export const HOST_NOTIFICATION_EVENT_TYPES = {
  TASK_CREATED: 'task.created',
  TASK_PROGRESS: 'task.progress',
  TASK_COMPLETED: 'task.completed',
  TASK_FAILED: 'task.failed',
  HIL_CREATED: 'hil.created',
  SYSTEM_BROADCAST: 'system.broadcast',
  CANVAS_UPDATED: 'canvas-updated',
} as const;

export const HOST_NOTIFICATION_EVENT_TYPE_LIST = [
  HOST_NOTIFICATION_EVENT_TYPES.TASK_CREATED,
  HOST_NOTIFICATION_EVENT_TYPES.TASK_PROGRESS,
  HOST_NOTIFICATION_EVENT_TYPES.TASK_COMPLETED,
  HOST_NOTIFICATION_EVENT_TYPES.TASK_FAILED,
  HOST_NOTIFICATION_EVENT_TYPES.HIL_CREATED,
  HOST_NOTIFICATION_EVENT_TYPES.SYSTEM_BROADCAST,
] as const;

export const CANVAS_UPDATED_EVENT_TYPE = HOST_NOTIFICATION_EVENT_TYPES.CANVAS_UPDATED;
